/*
  Marlas checkout terms - conversion fix, Oct 21 2026.
  - Checkout button stays grey until the policy box is ticked.
  - Tapping the grey button scrolls to the box and highlights it
    (replaces the old "please accept" pop-up that left shoppers stuck).
  - "Read policy" opens the policy with an "I agree" button that ticks the box.
  Listeners run in the capture phase, before the theme's own cart handlers.
*/
(function () {
  if (window.__marlasCheckoutTerms) return;
  window.__marlasCheckoutTerms = true;

  var POLICY_URL = '/pages/returns-and-exchange-policy';

  function scopeOf(el) {
    return (el && (el.closest('cart-drawer') || el.closest('.main-cart'))) || document;
  }
  function checkboxIn(scope) {
    return scope.querySelector('#CartTermsDrawer');
  }
  function checkoutButtonsIn(scope) {
    return scope.querySelectorAll('button[name="checkout"]');
  }

  function sync(scope) {
    var cb = checkboxIn(scope);
    if (!cb) return;
    checkoutButtonsIn(scope).forEach(function (btn) {
      btn.classList.toggle('is-disabled', !cb.checked);
      btn.setAttribute('aria-disabled', cb.checked ? 'false' : 'true');
    });
    var terms = cb.closest('.cart__terms');
    if (terms && cb.checked) terms.classList.remove('cart__terms--attention');
  }

  function syncAll() {
    document.querySelectorAll('#CartTermsDrawer').forEach(function (cb) {
      sync(scopeOf(cb));
    });
  }

  function nudge(scope) {
    var cb = checkboxIn(scope);
    var terms = cb && cb.closest('.cart__terms');
    if (!terms) return;
    terms.classList.remove('cart__terms--attention');
    void terms.offsetWidth; // restart the highlight animation
    terms.classList.add('cart__terms--attention');
    terms.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function popupRoot(scope) {
    return scope !== document && scope.querySelector('#shipping_popup') ? scope : document;
  }

  function closePolicy(root) {
    var popup = root.querySelector('#shipping_popup');
    var inner = root.querySelector('#shipping_popup_inner');
    var overlay = root.querySelector('.shipping_popup_overlay');
    if (inner) inner.innerHTML = '';
    if (popup) popup.style.display = 'none';
    if (overlay) overlay.style.display = 'none';
    document.body.classList.remove('popup');
  }

  function openPolicy(scope) {
    var root = popupRoot(scope);
    var popup = root.querySelector('#shipping_popup');
    var inner = root.querySelector('#shipping_popup_inner');
    var overlay = root.querySelector('.shipping_popup_overlay');
    var loader = root.querySelector('.loader');

    if (!popup || !inner) {
      window.location.href = POLICY_URL;
      return;
    }

    if (loader) loader.style.display = 'block';
    if (overlay) overlay.style.display = 'block';

    fetch(POLICY_URL, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('.main-content');
        inner.innerHTML = content ? content.innerHTML : '';

        var bar = document.createElement('div');
        bar.className = 'terms-agree-bar';
        var agree = document.createElement('button');
        agree.type = 'button';
        agree.className = 'terms-agree-button';
        agree.textContent = 'I agree to this policy';
        agree.addEventListener('click', function () {
          var cb = checkboxIn(scope);
          if (cb && !cb.checked) {
            cb.checked = true;
            cb.dispatchEvent(new Event('change', { bubbles: true }));
          }
          sync(scope);
          closePolicy(root);
          var btn = checkoutButtonsIn(scope)[0];
          if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        bar.appendChild(agree);
        inner.appendChild(bar);

        popup.style.display = 'block';
        document.body.classList.add('popup');
      })
      .catch(function () {
        window.location.href = POLICY_URL;
      })
      .finally(function () {
        if (loader) loader.style.display = 'none';
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var checkoutBtn = target.closest('button[name="checkout"]');
    if (checkoutBtn) {
      var scope = scopeOf(checkoutBtn);
      var cb = checkboxIn(scope);
      if (!cb) return;
      if (!cb.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        nudge(scope);
      } else {
        sync(scope); // make sure no stale "disabled" state blocks a ticked shopper
      }
      return;
    }

    var policyLink = target.closest('.cart__terms .terms-content');
    if (policyLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openPolicy(scopeOf(policyLink));
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'CartTermsDrawer') {
      sync(scopeOf(event.target));
    }
  });

  document.addEventListener('cart-drawer:refreshed', syncAll);
  window.addEventListener('pageshow', syncAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
